import React from "react";
import ReactDOM from "react-dom/client";
import SamsEnergyLandingPage from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<SamsEnergyLandingPage />);
